import React from "react";

import { DeliveryTypes } from "@utils/enums";

import AmountDropDown from "./amountDropDown/amountDropDown.component";
import AmountInput from "./amountInput/amountInput.component";

import "./amount.scss";

type Props = {
    handleChange: (newQuantity: number, oldQuantity: number) => void;
    value: number;
    roundingValue: number | undefined;
    minimumOrderQuantity: number;
    maximumOrderQuantity: number;
    deliveryType?: DeliveryTypes;
    isFree?: boolean;
    isFreeEntryAddedByCustomer?: boolean;
    isUpdatingCart: boolean;
    hasProductMultipleCartEntries?: boolean;
};

const Amount = ({
    handleChange,
    value,
    roundingValue,
    minimumOrderQuantity,
    maximumOrderQuantity,
    deliveryType,
    isFree,
    isFreeEntryAddedByCustomer,
    isUpdatingCart,
    hasProductMultipleCartEntries,
}: Props) => {
    if (roundingValue === 1 || deliveryType === DeliveryTypes.ClickAndCollect) {
        return (
            <AmountInput
                handleChange={handleChange}
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                maximumOrderQuantity={maximumOrderQuantity}
                roundingValue={roundingValue}
                value={value}
                isFree={isFree}
                isFreeEntryAddedByCustomer={isFreeEntryAddedByCustomer}
                hasProductMultipleCartEntries={hasProductMultipleCartEntries}
                deliveryType={deliveryType}
            />
        );
    } else {
        return (
            <AmountDropDown
                handleChange={handleChange}
                value={value}
                roundingValue={roundingValue}
                minimumOrderQuantity={minimumOrderQuantity}
                maximumOrderQuantity={maximumOrderQuantity}
                isUpdatingCart={isUpdatingCart}
            />
        );
    }
};

export { Amount };
